export const OVERVIEW = 'Overview';
export const LEARN_MORE_LINK = 'Learn More';
export const NEWSROOM_READ_MORE = 'Read More';
export const BACK_BUTTON = 'Back to homepage';
export const PREVIOUS = 'Prev';
export const NEXT = 'Next';
